import module from './module.js'
/* Routes */
import './routes/proyectos.js'
import './routes/proyectos/agregar.js'
/* Components */
export * from './components/component.js'
export * from './components/agregar/component.js'
export * from './components/agregar/confirmar/component.js'
/* Services */
export * from './services/Proyectos.js'
export * from './services/Catalogos/Clientes.js'
export * from './services/Catalogos/Empresas.js'
export * from './services/Catalogos/Estados.js'

export default module.name



// WEBPACK FOOTER //
// ./src/fan/proyectos/index.js